<script setup>
  import { computed } from 'vue'

  const props = defineProps({
    badges: Array,
    reservedCount: Number,
  })

  const randomBadges = computed(() => {
    const count = Math.max(0, 4 - props.reservedCount)
    const selected = new Set([...props.badges].sort(() => Math.random() - 0.5).slice(0, count))
    return props.badges.filter((b) => selected.has(b))
  })
</script>

<template>
  <li v-for="feature in randomBadges" :key="`badge-${feature.key}`" :class="feature.class_name" v-html="feature.label"></li>
</template>
